import { useState, useRef, Fragment } from "react";
import Config from "../../Config";

import PlTitle from "../../elements/PlTitle";
import InputPagger from "../../helpers/InputPagger";

import InputComboGrupa from "../../helpers/InputComboGrupa";

import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";
import InputComboStawkiWyz from "../../helpers/InputComboStawkiWyz";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";


import XDateFee from "./XDateFee";
import AppContext from "../../AppContext";
import Xlsx from "../../exporter/Xlsx";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputCombo from "../../helpers/InputCombo";

function Free(props)
{
    const tabRef = useRef(0);
    const tab2Ref = useRef(0);    


    const tabRefP = useRef(0);
    const tab2RefP = useRef(0);    


    const [optionArch, setOptionArch]  = useState([
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '0',
            title: 'Dziecko aktywne'
        }, {
            v: '1',
            title: 'Dziecko w archiwum'
        }
    ]
    );


    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [groups, setGroups] = useState(null);

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''),        
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'),
        rok: (new Date()).getFullYear() ,
        miesiac: (new Date() ).getMonth()+1,
        p_typy_oplat_id: props.mainView.readFilter('p_typy_oplat_id','_x_'),
        archiwalne: "0",
        limit: 50,
        page: 1,
        pages: 1,
        show: true, 
    });
    const [tab, setTab] = useState(null);
    const [tabSums, setTabSums] = useState(null);


    var dt = new Date();
    const [showDay, setShowDay] = useState({
        from: dt.getDate() - 3,
        to: dt.getDate() + 3,
    });
    const [strToDay, setStrToDate] = useState( dt.toISOString().split`T`[0]  ); 

 

    const getGroup = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,gr', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setGroups(res.result);    
                        
                        if(res.result.length > 1)
                        {
                            setFilterParam(  {...filterParam, ["p_grupa_id"]: res.result[1].v  } );
                            //console.log('GrupaXXX',  res.result[1].v );
                        }
                               
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,free', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);       
                        setTabSums(res.sums);     
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

  

    const valChangeListener = (filedName, val, correct, msg) => {

       // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {
        setFilterParam({
            d_imie_nazwisko: '',     
            p_grupa_id: '_x_',
            rok: (new Date()).getFullYear() ,
            miesiac: (new Date() ).getMonth()+1,   
            p_typy_oplat_id: '_x_',      
            archiwalne: "0",  
            limit: 50,
            page: 1,
            show: true,
        });
        setTab(null);

        props.mainView.writeFilter('d_imie_nazwisko', '');    
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }



    const zmienStatus = (e) => {
       

        //dzien={dd.dzien} p_typy_oplat_id={dd.p_typy_oplat_id}  p_dziecko_id={dd.p_dziecko_id} 


        var dzien = e.target.getAttribute('dzien');
        var p_typy_oplat_id = e.target.getAttribute('p_typy_oplat_id');
        var p_dziecko_id = e.target.getAttribute('p_dziecko_id');


        var req = {
            dzien: dzien,
            p_typy_oplat_id: p_typy_oplat_id,
            p_dziecko_id: p_dziecko_id, 
        };

     
      
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,free_change', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       getTab();           
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    if(groups == null)
    {
        setGroups([])
        getGroup();        
    }

    if(groups == null ||  groups.length < 1) //najpierw pobierz grupy...
    {
        return <div>             
        </div>
    }


    if(tab == null)
        {
            setTab([]);
            getTab();
         
    
            return <div>
                ...
            </div>
        }

    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setGroups(null);
            setTab(null);           
        }




    var sumOB = [];
    var sumNB = [];
    var sumPO = [];

 
    var sumKW = 0;
    var sumKW_pdf = 0;

  
    for(var r=0; r<tab.length; r++)
        {
            for(var d=0; d < tab[r].dni.length; d++ )
                {
                    sumOB.push(  {  dzien: tab[r].dni[d].dzien, ilosc: 0  }  );                     
                    sumNB.push(  {  dzien: tab[r].dni[d].dzien, ilosc: 0  }  ); 
                    sumPO.push(  {  dzien: tab[r].dni[d].dzien, ilosc: 0  }  ); 
 
                }    
                break;      
        }


        for(var r=0; r<tab.length; r++)
            {
                for(var d=0; d < tab[r].dni.length; d++ )
                    {

                        var xOB = 0;
                        var xNB = 0;
                        var xPO = 0;

                            if( tab[r].dni[d].nb == '1' )
                            {
                                if( tab[r].dni[d].aktywna == '1'  )  xNB = 1;  //tu dodane...

                                if( tab[r].dni[d].po_czasie == '1' ){
                                    xPO = 1;
                                }

                            }else
                            {
                                if( tab[r].dni[d].aktywna == '1'  )  //tu dodane...
                                     xOB = 1;
                            }

                        if(xOB > 0)    
                            {
                                for(var xt =0; xt<sumOB.length; xt++)
                                    {
                                        if(sumOB[xt].dzien == tab[r].dni[d].dzien )
                                            {
                                                sumOB[xt].ilosc++;   
                                                
                                            }
                                    }
                            }

                        if(xNB > 0)    
                                {
                                    for(var xt =0; xt<sumNB.length; xt++)
                                        {
                                            if(sumNB[xt].dzien == tab[r].dni[d].dzien )
                                                {
                                                    sumNB[xt].ilosc++;   
                                                }
                                        }
                                }

                        if(xPO > 0)    
                                    {
                                        for(var xt =0; xt<sumPO.length; xt++)
                                            {
                                                if(sumPO[xt].dzien == tab[r].dni[d].dzien )
                                                    {
                                                        sumPO[xt].ilosc++;   
                                                    }
                                            }
                                    }

                    }    
                    
            }        

 
        //    alert(JSON.stringify(sumOB) );


     

    var titleRaport = filterParam.rok + "-" +  filterParam.miesiac;
    
    if(filterParam.p_grupa_id == "_x_") titleRaport += " wszystkie grupy";

    if(filterParam.p_grupa_id != '_x_')
    {
        for(var k=0; k < groups.length; k++)
        {
            if(groups[k].v == filterParam.p_grupa_id)
            {
                titleRaport +=  " " + groups[k].title;
            }
        }
    }



    


    var date = new Date();
    var toDateYMD = date.toISOString().slice(0,10);



    return (
        <div className="view_content">


            {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
            } 


            {
                    filterParam.show == true  &&
                    <div className="table_filter">
               
                             <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Grupa: "}   />
                            </div> 



               
                           <div className="filter_controll">   
                                <label>Dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div>  

                            <div className="filter_controll">   
                                    <label>Archiwum: </label>                             
                                    <InputCombo   userData={props.userData} value={filterParam.archiwalne} items={optionArch}  valChange={valChangeListener} goNext={goNextNew} name="archiwalne" placeholder={"Archiwalne: "}   />
                            </div> 
  

                            <div className="filter_controll">   
                                <label>Rok: </label>                             
                                <InputComboRok   userData={props.userData}  mainView={props.mainView}  value={filterParam.rok}   valChange={valChangeListener} goNext={goNextNew} name="rok" placeholder={": "}  noempty="1"   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Miesiąc: </label>                             
                                <InputComboMiesiac   userData={props.userData}  mainView={props.mainView}  value={filterParam.miesiac}   valChange={valChangeListener} goNext={goNextNew} name="miesiac" placeholder={": "}  noempty="1"   />
                            </div> 


                            <div className="filter_controll">   
                                <label>Posiłek / Stawka: </label>                             
                                <InputComboStawkiWyz  userData={props.userData}  mainView={props.mainView}  value={filterParam.p_typy_oplat_id}   valChange={valChangeListener} goNext={goNextNew} name="p_typy_oplat_id" placeholder={": "}    />
                            </div> 


                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                            </div>

            </div>
            } 
 


                {
                            tabSums != null && tabSums.length > 0 &&
                               <Fragment>


                                <div ref={tabRefP} className="gohide">
                                        <h3>Podsumowanie na dzisiaj {toDateYMD}</h3> 
                                          <table className="table" ref={tab2RefP}  >
                                            <thead>
                                                <tr className="header">
                                                                <td className="td_left">LP</td>     
                                                                <td className="">Nazwa stawki</td>     
                                                                <td className="">Obecnych</td>     
                                                                <td className="">Nieobecnych</td>     
                                                                <td className="td_right">Po czasie</td>     
                                                </tr>
                                            </thead>

                                            <tbody>
                                                        {
                                                            tabSums.map(  (item, ix) => {

                                                                        var rowStyle = " row ";
                                                                        if(ix % 2 == 0 )rowStyle = " row2 ";  

                                                                        return  <tr className={rowStyle}>
                                                                        <td className="gocenter">{ix+1}</td>     
                                                                        <td className="">{item.nazwa}</td>     
                                                                        <td className="gocenter">{item.obecnych}</td>     
                                                                        <td className="gocenter">{item.nieobecnych}</td>     
                                                                        <td className="gocenter">{item.poczasie}</td>     
                                                                    </tr>

                                                            } )
                                                        }
                                            </tbody>
                                        </table>
                                </div>


                                        <div className="scorll_x">

                                        <div className="calColor bk_before">Podsumowanie na dzisiaj {toDateYMD}</div>

                                        <div className="table_widget">                                                                        
                                                <HtmlToPDF tabRef={tabRefP} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={ "Podsumowanie na dzisiaj " + toDateYMD  } />                                    
        
                                                <Csv tabRef={tab2RefP} title={"Podsumowanie na dzisiaj " + toDateYMD  } />
                                                <Xlsx tabRef={tab2RefP}  title={ "Podsumowanie na dzisiaj " + toDateYMD  } />
                        
                                                <Print tabRef={tab2RefP} title={ "Podsumowanie na dzisiaj " + toDateYMD  }  />
                                        </div>

                                        <table className="table" >
                                            <thead>
                                                <tr className="header">
                                                                <td className="td_left">LP</td>     
                                                                <td className="">Nazwa stawki</td>     
                                                                <td className="">Obecnych</td>     
                                                                <td className="">Nieobecnych</td>     
                                                                <td className="td_right">Po czasie</td>     
                                                </tr>
                                            </thead>

                                            <tbody>
                                                        {
                                                            tabSums.map(  (item, ix) => {

                                                                        var rowStyle = " row ";
                                                                        if(ix % 2 == 0 )rowStyle = " row2 ";  

                                                                        return  <tr className={rowStyle}>
                                                                        <td className="gocenter">{ix+1}</td>     
                                                                        <td className="">{item.nazwa}</td>     
                                                                        <td className="gocenter">{item.obecnych}</td>     
                                                                        <td className="gocenter">{item.nieobecnych}</td>     
                                                                        <td className="gocenter">{item.poczasie}</td>     
                                                                    </tr>

                                                            } )
                                                        }
                                            </tbody>
                                        </table>

                                        <br/>
                                        <br/>
                                        </div>

                            </Fragment>
                          }

           




            <div className="table_widget">                                                                        
                                        <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={"Nieobecności, " + titleRaport } />                                    
 
                                        <Csv tabRef={tab2Ref} title={"Nieobecności, "  + titleRaport } />
                                        <Xlsx tabRef={tab2Ref}  title={"Nieobecności, " + titleRaport } />
                  
                                        <Print tabRef={tab2Ref} title={"Nieobecności, " + titleRaport }  />
                                </div>



            <div className="bg_center">                                                            


                                <div ref={tabRef} className="gohide">
                                <h3>Nieobecności {filterParam.rok + "-" + filterParam.miesiac }</h3>   
                                        <table className="table" >


                                                <thead>
                                                    <tr className="header">
                                                        <td className="td_left">LP</td>                                                 
                                                        <td>Dziecko</td>  
                                                        <td>Stawka</td>         
                                                       

                                                        {
                                                            tab.map( (row, ix) => {

                                                                if(ix > 0) return null;

                                                                return (
                                                                    row.dni.map( (dd, id) => {
                                                                        return (
                                                                            <td>{id+1}</td>
                                                                        )
                                                                    } )
                                                                )
                                                              

                                                            } )
                                                        }

                                                        <td>NB</td>
                                                        <td>OB</td>
                                                        <td>Il.</td>
                                                        {
                                                            props.userData.type == "DYREKTOR" &&
                                                            <Fragment>
                                                                    <td>St.</td>
                                                                    <td className="td_right">Kw.</td>
                                                            </Fragment>
                                                        }
                                                        

                                                    </tr>
                                                </thead>
                                                
                                                <tbody>

                                                        {
                                                  

                                                            tab.map( (row, ix) => {

                                                                var razemNB = 0;
                                                                var razemOB = 0;       
                                                                
                                                                var iloscRoz   = 0;
                                                                var razemKwota = 0;


                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                return (
                                                                    <tr className={rowStyle}>
                                                                        <td className="gocenter">{ix+1}</td>                                                  
                                                                        <td>{row.nazwisko + " " + row.imie}</td>  
                                                                        <td>{row.stawka}</td>    
                                                                      

                                                                        {
                                                                            row.dni.map( (dd, id) => {

                                                                                var clsTD = " e_square_center ";
                                                                                var clsSquare = "e_ob_def";

                                                                                var infoDay = "Dzień: " + dd.dzien + "<br/><br/>";


                                                                                 if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                 if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                 if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                 if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                                 if( !(dd.w == '6' || dd.w == '0' || dd.wolne == '1' ) )
                                                                                    {

                                                                                        if(dd.nb == '1')
                                                                                            {
                                                                                                razemNB = razemNB + 1;

                                                                                                clsSquare = "e_nb";

                                                                                                if(dd.po_czasie == '0')    
                                                                                                    {
                                                                                                        //jest ok - nie liczymy

                                                                                                        infoDay = infoDay +  "Nieobecność zgłoszona w czasie<br/>";
                                                                                                    }else 
                                                                                                    {
                                                                                                        infoDay = infoDay +  "Nieobecność zgłoszona po czasie<br/>";

                                                                                                        clsSquare = "e_nbpc";

                                                                                                        iloscRoz = iloscRoz + 1;
                                                                                                        razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota_netto);

                                                                                                      //  sumKW = parseFloat(sumKW) + parseFloat(row.kwota_netto);
                                                                                                    }
                                                                                            }else
                                                                                            {
                                                                                                if(dd.aktywna == '1') 
                                                                                                {
                                                                                                    razemOB = razemOB + 1;
                                                                                                        
                                                                                                    iloscRoz   = iloscRoz + 1;
                                                                                                    razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota_netto);

                                                                                                    // sumKW = parseFloat(sumKW) + parseFloat(row.kwota_netto);
                                                                                                }
                                                                                            }

                                                                                            if(dd.aktywna == '0')
                                                                                                {
                                                                                                    clsSquare = "e_black";
                                                                                                }

                                                                                    }
                                                                              
                                                                                if( (dd.w == '6' || dd.w == '0' || dd.wolne == '1'   ) )    
                                                                                    {
                                                                                        return (
                                                                                            <td className={clsTD}>
                                                                                                                                                                                 
                                                                                            </td>
                                                                                        )
                                                                                    }                                                                           

                                                                                if(dd.aktywna == '0')    
                                                                                    {
                                                                                        infoDay = 'Stawka nie obowiązuje w ten dzień';
                                                                                        return (
                                                                                            <td className={clsTD }  >
                                                                                                <span className={"e_squere " + clsSquare } status={dd.status}   dzien={dd.dzien} p_typy_oplat_id={row.p_typy_oplat_id}  p_dziecko_id={dd.p_dziecko_id}   >
                                                                                                   &nbsp;&nbsp;
                                                                                                </span>                                                                                   
                                                                                            </td>
                                                                                        )
                                                                                    }

                                                                                infoDay = row.imie+" " + row.nazwisko + "<br/>" +  infoDay +  "<br/>"
                                                                                for(var mx=0; mx<dd.h.length; mx++)   
                                                                                    {
                                                                                        infoDay = infoDay +  dd.h[mx].data + " " + dd.h[mx].imie + " " + dd.h[mx].nazwisko + "<br/>"
                                                                                    }


                                                                                return (
                                                                                    <td className={clsTD}  >
                                                                                        <span className={"e_squere txtcloud " + clsSquare } status={dd.status}   dzien={dd.dzien} p_typy_oplat_id={row.p_typy_oplat_id}  p_dziecko_id={row.p_dziecko_id} onClick={zmienStatus}  >
                                                                                            <span className="info_content">
                                                                                                &nbsp;&nbsp;
                                                                                            </span>                                                                                        
                                                                                        </span>                                                                                   
                                                                                    </td>
                                                                                )
                                                                            } )

                                                                           
                                                                           
                                                                        }

                                                                        <td className="gocenter e_nb_txt" >{razemNB}</td>
                                                                        <td className="gocenter">{razemOB}</td>

                                                                        <td className="goright gobold">{(parseFloat(iloscRoz).toFixed(0)).replace(".",",")}</td>   

                                                                        {
                                                                            props.userData.type == "DYREKTOR" &&
                                                                            <Fragment>
                                                                                     <td className="goright gobold">{(parseFloat(row.kwota_netto).toFixed(2)).replace(".",",")}</td>   
                                                                                     <td className="goright gobold">{ (parseFloat(razemKwota).toFixed(2)).replace(".",",")}</td>
                                                                            </Fragment>
                                                                        }

                                                                            
                                                                       

                                                                    </tr>
                                                                )

                                                            } )
                                                        }


                                                                <tr className="row2">
                                                                        <td className="gocenter"> &nbsp; </td>                                                  
                                                                        <td> &nbsp;</td>  
                                                                        <td className="gobold"> Obecnych </td>  
                                                                      

                                                                        {
                                                                            sumOB.map( (item, iKey) =>{
                                                                                        return (
                                                                                            <td>{item.ilosc}</td>
                                                                                        )
                                                                            }    )

                                                                        }

                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  

                                                                        {
                                                                            props.userData.type == "DYREKTOR" &&
                                                                            <Fragment>
                                                                                     <td className="gobold link_color"><FormatDecimal value={sumKW} /></td>                                                                                    
                                                                            </Fragment>
                                                                        }
                                                                                                                                           
                                                                </tr>

                                                                
                                                                <tr className="row">
                                                                        <td className="gocenter"> &nbsp; </td>                                                  
                                                                        <td> &nbsp;</td>  
                                                                        <td  className="gobold e_nb_txt"> Nieobecnych </td>  
                                                                       

                                                                        {
                                                                            sumNB.map( (item, iKey) =>{
                                                                                        return (
                                                                                            <td className="e_nb_txt">{item.ilosc}</td>
                                                                                        )
                                                                            }    )

                                                                        }

                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  

                                                                        {
                                                                            props.userData.type == "DYREKTOR" &&
                                                                            <Fragment>
                                                                                     <td> &nbsp;</td>                                                                                       
                                                                            </Fragment>
                                                                        }  
                                                                </tr>

                                                                <tr className="row2">
                                                                        <td className="gocenter"> &nbsp; </td>                                                  
                                                                        <td> &nbsp;</td>  
                                                                        <td className="e_nbpc_txt"> Nieobecnych (Po czasie) </td>  
                                                                      

                                                                        {
                                                                            sumPO.map( (item, iKey) =>{
                                                                                        return (
                                                                                            <td className="e_nbpc_txt">{item.ilosc}</td>
                                                                                        )
                                                                            }    )

                                                                        }

                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  

                                                                        {
                                                                            props.userData.type == "DYREKTOR" &&
                                                                            <Fragment>
                                                                                     <td> &nbsp;</td>                                                                               
                                                                            </Fragment>
                                                                        }     
                                                                </tr>

                                                </tbody>

                                        </table>
                                </div>
                             

                                <table className="table gohide" ref={tab2Ref}  >
                                                        <thead>
                                                            <tr className="header">
                                                                <td>LP</td>                                                 
                                                                <td>Dziecko</td>  
                                                                <td>Stawka</td>         

                                                                {
                                                                    tab.map( (row, ix) => {

                                                                        if(ix > 0) return null;

                                                                        return (
                                                                            row.dni.map( (dd, id) => {
                                                                                return (
                                                                                    <td>{id+1}</td>
                                                                                )
                                                                            } )
                                                                        )
                                                                    

                                                                    } )
                                                                }

                                                                <td>NB</td>
                                                                <td>OB</td>
                                                                <td>Il.</td>
                                                                
                                                                {
                                                                    props.userData.type == "DYREKTOR" &&
                                                                    <td>Kw.</td>
                                                                }    

                                                            </tr>
                                                        </thead>

                                                        <tbody>

                                                                {
                                                        

                                                                    tab.map( (row, ix) => {

                                                                        var razemNB = 0;
                                                                        var razemOB = 0;       
                                                                        
                                                                        var iloscRoz   = 0;
                                                                        var razemKwota = 0;

                                                                        return (
                                                                            <tr className="row">
                                                                                <td className="gocenter">{ix+1}</td>                                                  
                                                                                <td>{row.nazwisko + " " + row.imie}</td>  
                                                                                <td>{row.stawka}</td>    

                                                                                {
                                                                                    row.dni.map( (dd, id) => {

                                                                                        var clsTD = " e_square_center ";
                                                                                        var clsSquare = "e_ob_def";

                                                                                        var infoDay = "Dzień: " + dd.dzien + "<br/><br/>";


                                                                                        if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                        if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                        if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                        if( !(dd.w == '6' || dd.w == '0' || dd.wolne == '1' ) )
                                                                                            {

                                                                                                if(dd.nb == '1')
                                                                                                    {
                                                                                                        razemNB = razemNB + 1;

                                                                                                        clsSquare = "e_nb";

                                                                                                        if(dd.po_czasie == '0')    
                                                                                                            {
                                                                                                                //jest ok - nie liczymy

                                                                                                                infoDay = infoDay +  "Nieobecność zgłoszona w czasie<br/>";
                                                                                                            }else 
                                                                                                            {
                                                                                                                infoDay = infoDay +  "Nieobecność zgłoszona po czasie<br/>";

                                                                                                                clsSquare = "e_nbpc";

                                                                                                                iloscRoz = iloscRoz + 1;
                                                                                                                razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota_netto);
                                                                                                            }
                                                                                                    }else
                                                                                                    {
                                                                                                        razemOB = razemOB + 1;

                                                                                                        iloscRoz = iloscRoz + 1;
                                                                                                        razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota_netto);
                                                                                                    }

                                                                                            }
                                                                                    
                                                                                        if( (dd.w == '6' || dd.w == '0' || dd.wolne == '1' ) )    
                                                                                            {
                                                                                                return (
                                                                                                    <td className={clsTD}>
                                                                                                        --
                                                                                                    </td>
                                                                                                )
                                                                                            }

                                                                                        infoDay = infoDay +  "<br/>"
                                                                                        for(var mx=0; mx<dd.h.length; mx++)   
                                                                                            {
                                                                                                infoDay = infoDay +  dd.h[mx].data + " " + dd.h[mx].imie + " " + dd.h[mx].nazwisko + "<br/>"
                                                                                            }


                                                                                        var cellVal = "OB";
                                                                                        if( clsSquare == "e_nb" )   cellVal = "NB";
                                                                                        if( clsSquare == "e_nbpc" ) cellVal = "NB(Po czasie)";

                                                                                        return (
                                                                                            <td className={clsTD}  >
                                                                                                {cellVal  }                                                                                 
                                                                                            </td>
                                                                                        )
                                                                                    } )

                                                                                
                                                                                
                                                                                }

                                                                                <td className="gocenter e_nb_txt" >{razemNB}</td>
                                                                                <td className="gocenter">{razemOB}</td>

                                                                                <td className="goright gobold">{(parseFloat(iloscRoz).toFixed(2)).replace(".",",")}</td>   
                                                                             

                                                                                {
                                                                                    props.userData.type == "DYREKTOR" &&
                                                                                    <td className="goright gobold">{ (parseFloat(razemKwota).toFixed(2)).replace(".",",") }</td>
                                                                                }  

                                                                            </tr>
                                                                        )

                                                                    } )
                                                                }


                                                                        <tr className="row">
                                                                                <td className="gocenter"> &nbsp; </td>                                                  
                                                                                <td> &nbsp;</td>  
                                                                                <td className="gobold"> Obecnych </td>  

                                                                                {
                                                                                    sumOB.map( (item, iKey) =>{
                                                                                                return (
                                                                                                    <td>{item.ilosc}</td>
                                                                                                )
                                                                                    }    )

                                                                                }

                                                                                <td>  </td>  
                                                                                <td>  </td>  
                                                                                <td>  </td>  
                                                                                {
                                                                                    props.userData.type == "DYREKTOR" &&
                                                                                    <td></td>
                                                                                } 
                                                                        </tr>

                                                                        
                                                                        <tr className="row">
                                                                                <td className="gocenter">  </td>                                                  
                                                                                <td> </td>  
                                                                                <td  className="gobold e_nb_txt"> Nieobecnych </td>  

                                                                                {
                                                                                    sumNB.map( (item, iKey) =>{
                                                                                                return (
                                                                                                    <td className="e_nb_txt">{item.ilosc}</td>
                                                                                                )
                                                                                    }    )

                                                                                }

                                                                                <td>  </td>  
                                                                                <td>  </td>  
                                                                                <td> </td>  
                                                                                {
                                                                                    props.userData.type == "DYREKTOR" &&
                                                                                    <td></td>
                                                                                }  
                                                                        </tr>

                                                                        <tr className="row">
                                                                                <td className="gocenter"> </td>                                                  
                                                                                <td>  </td>  
                                                                                <td className="e_nbpc_txt"> Nieobecnych (Po czasie) </td>  

                                                                                {
                                                                                    sumPO.map( (item, iKey) =>{
                                                                                                return (
                                                                                                    <td className="e_nbpc_txt">{item.ilosc}</td>
                                                                                                )
                                                                                    }    )

                                                                                }

                                                                                <td>  </td>  
                                                                                <td>  </td>  
                                                                                <td>  </td>  
                                                                                {
                                                                                    props.userData.type == "DYREKTOR" &&
                                                                                    <td></td>
                                                                                }  
                                                                        </tr>

                                                        </tbody>

                                        </table>
                           



                  
                         


                            <div className="scorll_x">
                                    <table className="table" >


                                                <thead>
                                                    <tr className="header">
                                                        <td className="td_left">LP</td>                                                 
                                                        <td>Dziecko</td>  
                                                        <td>Stawka</td>         
                                                       

                                                        {
                                                            tab.map( (row, ix) => {

                                                                if(ix > 0) return null;

                                                                return (
                                                                    row.dni.map( (dd, id) => {
                                                                        return (
                                                                            <td>{id+1}</td>
                                                                        )
                                                                    } )
                                                                )
                                                              

                                                            } )
                                                        }

                                                        <td>NB</td>
                                                        <td>OB</td>
                                                        <td>Il.</td>
                                                        {
                                                            props.userData.type == "DYREKTOR" &&
                                                            <Fragment>
                                                                    <td>St.</td>
                                                                    <td className="td_right">Kw.</td>
                                                            </Fragment>
                                                        }
                                                        

                                                    </tr>
                                                </thead>
                                                
                                                <tbody>

                                                        {
                                                  

                                                            tab.map( (row, ix) => {

                                                                var razemNB = 0;
                                                                var razemOB = 0;       
                                                                
                                                                var iloscRoz   = 0;
                                                                var razemKwota = 0;


                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                return (
                                                                    <tr className={rowStyle}>
                                                                        <td className="gocenter">{ix+1}</td>                                                  
                                                                        <td>{row.nazwisko + " " + row.imie}</td>  
                                                                        <td>{row.stawka} <sup class="quick_tip" title={"Umowa nr " + row.numer_umowy}>&nbsp;?&nbsp;</sup> </td>    
                                                                      

                                                                        {
                                                                            row.dni.map( (dd, id) => {

                                                                                var clsTD = " e_square_center ";
                                                                                var clsSquare = "e_ob_def";

                                                                                var infoDay = "Dzień: " + dd.dzien + "<br/><br/>";


                                                                                 if(dd.w == '6')      clsTD ="e_square_center e_squere_sb";
                                                                                 if(dd.w == '0')      clsTD ="e_square_center e_squere_nd";
                                                                                 if(dd.wolne == '1')  clsTD ="e_square_center e_squere_free";

                                                                                 if(dd.dzien == strToDay)     clsTD = clsTD + " e_squere_today ";

                                                                                 if( !(dd.w == '6' || dd.w == '0' || dd.wolne == '1' ) )
                                                                                    {

                                                                                        if(dd.nb == '1')
                                                                                            {
                                                                                                razemNB = razemNB + 1;

                                                                                                clsSquare = "e_nb";

                                                                                                if(dd.po_czasie == '0')    
                                                                                                    {
                                                                                                        //jest ok - nie liczymy

                                                                                                        infoDay = infoDay +  "Nieobecność zgłoszona w czasie<br/>";
                                                                                                    }else 
                                                                                                    {
                                                                                                        infoDay = infoDay +  "Nieobecność zgłoszona po czasie<br/>";

                                                                                                        clsSquare = "e_nbpc";

                                                                                                        iloscRoz = iloscRoz + 1;
                                                                                                        razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota_netto);

                                                                                                        sumKW = parseFloat(sumKW) + parseFloat(row.kwota_netto);
                                                                                                    }
                                                                                            }else
                                                                                            {
                                                                                                if(dd.aktywna == '1') 
                                                                                                {
                                                                                                    razemOB = razemOB + 1;
                                                                                                        
                                                                                                    iloscRoz = iloscRoz + 1;
                                                                                                    razemKwota = parseFloat(razemKwota) + parseFloat(row.kwota_netto);

                                                                                                    sumKW = parseFloat(sumKW) + parseFloat(row.kwota_netto);
                                                                                                }
                                                                                            }

                                                                                            if(dd.aktywna == '0')
                                                                                                {
                                                                                                    clsSquare = "e_black";
                                                                                                }

                                                                                    }
                                                                              
                                                                                if( (dd.w == '6' || dd.w == '0' || dd.wolne == '1'   ) )    
                                                                                    {
                                                                                        return (
                                                                                            <td className={clsTD}>
                                                                                                                                                                                 
                                                                                            </td>
                                                                                        )
                                                                                    }                                                                           

                                                                                if(dd.aktywna == '0')    
                                                                                    {
                                                                                        infoDay = 'Stawka nie obowiązuje w ten dzień';
                                                                                        return (
                                                                                            <td className={clsTD}  >
                                                                                                <span className={"e_squere " + clsSquare } status={dd.status}   dzien={dd.dzien} p_typy_oplat_id={row.p_typy_oplat_id}  p_dziecko_id={dd.p_dziecko_id}   >
                                                                                                    <span className="info_day shadowx" dangerouslySetInnerHTML={{__html: infoDay}}   >
                                                                                                          
                                                                                                    </span>
                                                                                                </span>                                                                                   
                                                                                            </td>
                                                                                        )
                                                                                    }

                                                                                infoDay = row.imie+" " + row.nazwisko + "<br/>" +  infoDay +  "<br/>"
                                                                                for(var mx=0; mx<dd.h.length; mx++)   
                                                                                    {
                                                                                        infoDay = infoDay +  dd.h[mx].data + " " + dd.h[mx].imie + " " + dd.h[mx].nazwisko + "<br/>"
                                                                                    }


                                                                                return (
                                                                                    <td className={clsTD}  >
                                                                                        <span className={"e_squere txtcloud " + clsSquare } status={dd.status}   dzien={dd.dzien} p_typy_oplat_id={row.p_typy_oplat_id}  p_dziecko_id={row.p_dziecko_id} onClick={zmienStatus}  >
                                                                                            <span className="info_content">
                                                                                               <span className="info_cloud shadowx" dangerouslySetInnerHTML={{__html: infoDay}}   >                                                                                                  
                                                                                               </span>
                                                                                            </span>                                                                                        
                                                                                        </span>                                                                                   
                                                                                    </td>
                                                                                )
                                                                            } )

                                                                           
                                                                           
                                                                        }

                                                                        <td className="gocenter e_nb_txt" >{razemNB}</td>
                                                                        <td className="gocenter">{razemOB}</td>

                                                                        <td className="goright gobold">{(parseFloat(iloscRoz).toFixed(0)).replace(".",",")}</td>   

                                                                        {
                                                                            props.userData.type == "DYREKTOR" &&
                                                                            <Fragment>
                                                                                     <td className="goright gobold">{(parseFloat(row.kwota_netto).toFixed(2)).replace(".",",")}</td>   
                                                                                     <td className="goright gobold">{ (parseFloat(razemKwota).toFixed(2)).replace(".",",")}</td>
                                                                            </Fragment>
                                                                        }

                                                                            
                                                                       

                                                                    </tr>
                                                                )

                                                            } )
                                                        }


                                                                <tr className="row2">
                                                                        <td className="gocenter"> &nbsp; </td>                                                  
                                                                        <td> &nbsp;</td>  
                                                                        <td className="gobold"> Obecnych </td>  
                                                                      

                                                                        {
                                                                            sumOB.map( (item, iKey) =>{
                                                                                        return (
                                                                                            <td>{item.ilosc}</td>
                                                                                        )
                                                                            }    )

                                                                        }

                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  

                                                                        {
                                                                            props.userData.type == "DYREKTOR" &&
                                                                            <Fragment>
                                                                                     <td className="gobold link_color"><FormatDecimal value={sumKW} /></td>                                                                                    
                                                                            </Fragment>
                                                                        }
                                                                                                                                           
                                                                </tr>

                                                                
                                                                <tr className="row">
                                                                        <td className="gocenter"> &nbsp; </td>                                                  
                                                                        <td> &nbsp;</td>  
                                                                        <td  className="gobold e_nb_txt"> Nieobecnych </td>  
                                                                       

                                                                        {
                                                                            sumNB.map( (item, iKey) =>{
                                                                                        return (
                                                                                            <td className="e_nb_txt">{item.ilosc}</td>
                                                                                        )
                                                                            }    )

                                                                        }

                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  

                                                                        {
                                                                            props.userData.type == "DYREKTOR" &&
                                                                            <Fragment>
                                                                                     <td> &nbsp;</td>                                                                                       
                                                                            </Fragment>
                                                                        }  
                                                                </tr>

                                                                <tr className="row2">
                                                                        <td className="gocenter"> &nbsp; </td>                                                  
                                                                        <td> &nbsp;</td>  
                                                                        <td className="e_nbpc_txt"> Nieobecnych (Po czasie) </td>  
                                                                      

                                                                        {
                                                                            sumPO.map( (item, iKey) =>{
                                                                                        return (
                                                                                            <td className="e_nbpc_txt">{item.ilosc}</td>
                                                                                        )
                                                                            }    )

                                                                        }

                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  
                                                                        <td> &nbsp;</td>  

                                                                        {
                                                                            props.userData.type == "DYREKTOR" &&
                                                                            <Fragment>
                                                                                     <td> &nbsp;</td>                                                                               
                                                                            </Fragment>
                                                                        }     
                                                                </tr>

                                                </tbody>

                                        </table>
                            </div>

            </div>
            <br/><br/><br/>
            <div>
                &nbsp;
            </div>


        </div>
    )
}

export default Free;